<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small v-if="error" style="color: red">Fehler beim Erstellen des Mandanten</small>
            <v-form v-model="valid" ref="form">
              <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="Mandantenname*"
                  :rules="rules.required"
                  v-model="newClient.companyName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="Kürzel*"
                  :rules="rules.required"
                  v-model="newClient.shortName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="newClient.adminEmail"
                  label="Administrator-Email*"
                  :rules="rules.email && rules.required"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-file-input :rules="rules.img" accept="image/*" label="Icon wählen" :show-size="true" @change="saveIcon"></v-file-input>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-color-picker
                dot-size="25"
                mode="hexa"
                v-model="color"
                hide-mode-switch
              ></v-color-picker>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <img v-if="newClient.imageUrl != null" :src="newClient.imageUrl" alt="Company logo" />
              </v-col>
            </v-row>
            </v-form>
          </v-container>
          <small>*zeigt benötigte Felder an</small>
        </v-card-text>
        <v-card-actions>
          <v-btn id="leftButton" text @click="close()">Abbrechen</v-btn>
          <v-btn
            id="rightButton"
            color="primary"
            @click="submitClient()"
          >
            Mandanten anlegen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import clientService from "@/components/clientService"
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      title: "Neuen Mandanten anlegen",
      rules: {
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        required: [value => !!value || "Muss ausgefüllt werden"],
        img: [value => !value || value.size < 51200 || 'Logo muss kleiner als 50KB sein']
      },
      newClient: {
        companyName: null,
        imageUrl: null,
        identityColor: null,
        shortName: null,
        adminEmail: null,
        activeState: true
      },
      error: false,
      showPassword: false,
      valid: true,
      color: '#000000'
    }),
    methods:{
      resetData(){
        this.newClient = {
          companyName: null,
          imageUrl: null,
          identityColor: null,
          shortName: null,
          adminEmail: null,
          activeState: true
        }
        this.error = false;
      },
      open() {
        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      submitClient() {
        if(this.$refs.form.validate()){
          this.newClient.activeState = true;
          this.newClient.identityColor = this.color.substring(1, this.color.length);
          clientService.addClient(this.newClient).then(() => {
            this.resolve();
            this.resetData();
            this.dialog = false;
            })
          .catch(e => {
            console.log(e)
            this.error = true;
          });
        }
      },
      saveIcon(uploadedFile){
        this.errorFileUpload = false;
        if(uploadedFile == null) this.newClient.imageUrl = null;
        if(uploadedFile.type != null && uploadedFile.type != "" && uploadedFile.size != null){
          if(uploadedFile.size < 51200 && uploadedFile.type.includes("image")){
            var reader = new FileReader()
            
            reader.readAsDataURL(uploadedFile)
            reader.onload = () => {
                this.newClient.imageUrl = reader.result;
            };
          }else{
            uploadedFile=null;
          }
        }
      },
      close(){
        this.reject();
        this.resetData();
        this.dialog = false;
      }
    }
  }
</script>


<style lang="scss">
.no-alpha {
  .v-color-picker__controls {
    .v-color-picker__preview {
      .v-color-picker__sliders {
        .v-color-picker__alpha {
          display: none;
        }
      }
    }
    .v-color-picker__edit {
      .v-color-picker__input:last-child {
        display: none;
      }
    }
  }
}

</style>